import { Switch } from '@headlessui/react';
import React, { useState, useEffect, useContext, useRef } from 'react';
import { format } from 'date-fns';
import { CheckoutContext } from './CheckoutContext';
import { numberFormat, showToast } from '../../../Utils';
import { ExclamationCircleIcon } from '@heroicons/react/24/solid';

function CheckoutConfirm(props) {
  const {data, updateData} = useContext(CheckoutContext);
  const [fullPayment, setFullPayment] = useState(!data.payment.isDP);
  const [DP, setDP] = useState(0);

  const name  = useRef();
  const phone = useRef();
  const email = useRef();

  useEffect(() => {
    data.payment.isDP = !fullPayment;
    updateData(data);
    if (fullPayment) {
      setDP(0);
    }
  }, [fullPayment])

  useEffect(() => {
    data.payment.DP = DP;
    updateData(data);
    setFullPayment(DP === 0);
  }, [DP])

  const percentages = [10,20,30,40,50];
  const subtotal = data.package.price * data.schedules.time.length;
  let totalAddon = 0;
  data.addons.map((addon) => {
    totalAddon += (addon.price * addon.qty);
  });
  let total = subtotal + totalAddon;

  const toggleFullPayment = (value) => {
    setFullPayment(data.venue.isDP && data.schedules.isDP ? value : true);
  }

  const validate = () => {
    if (
      (data.contact.name === undefined || data.contact.name === "") || 
      (data.contact.phone === undefined || data.contact.phone === "") || 
      (data.contact.email === undefined || data.contact.email === ""))
      return {valid: false, msg: "Silahkan lengkapi data pemesan"}
    
    if (data.payment.isDP && (data.payment.DP === 0))
      return {valid: false, msg: "Silahkan pilih total DP"}

    return {valid: true, msg: "OK"};
  }

  const onNext = () => {
    data.contact.name  = name.current.value;
    data.contact.phone = phone.current.value;
    data.contact.email = email.current.value;
    updateData(data);

    let {valid, msg} = validate();

    if (valid) {
      props.onNextPageConfirmed();
    } else {
      showToast("Error", "Alert", msg);
    }
  }

  return (
    <div className='md:flex md:gap-x-8 pt-12'>

      <div className='md:w-1/2 mb-8 md:mb-0'>
        <p className='text-md font-semibold mb-4'>Konfirmasi Pesanan</p>
        <div className='px-6 py-6 flex flex-col gap-y-8 border border-gray-300 rounded-xl mb-4 md:mb-0'>
          <div className='gap-y-6 flex'>

            <div className='gap-y-3 md:w-1/2 flex flex-col'>
              <p className='text-sm font-semibold text-gray-500'>Nama Venue</p>
              <p className='text-sm font-semibold text-gray-800'>{data.venue.name}</p>
            </div>

            {/*
            <div className='gap-y-3 w-1/2 flex flex-col'>
              <p className='text-sm font-semibold text-gray-500'>Nama Lapang</p>
              <p className='text-sm font-semibold text-gray-800'>Lapang 2</p>
            </div>
            */}

          </div>
          <div className='gap-y-6 flex'>

            <div className='gap-y-3 flex flex-col'>
              <p className='text-sm font-semibold text-gray-500'>Paket Dipilih</p>
              <p className='text-sm font-semibold text-gray-800'>
                {data.package.name} ({data.package.description})
              </p>
            </div>
          </div>

          <div className='gap-y-6 flex'>

            <div className='gap-y-3 w-1/2 flex flex-col'>
              <p className='text-sm font-semibold text-gray-500'>Jumlah Sesi</p>
              <p className='text-sm font-semibold text-gray-800'>
                {data.schedules.time.length} Sesi
              </p>
            </div>
            
            <div className='gap-y-3 w-1/2 flex flex-col'>
              <p className='text-sm font-semibold text-gray-500'>Tambahan Add On</p>
              {(data.addons.length > 0) ? data.addons.map((addon) => (
                <p key={addon.id} className='text-sm font-semibold text-gray-800'>{addon.name} {addon.qty} {addon.unit}</p>
              )) : (
                <p className='text-sm font-semibold text-gray-800'>-</p>
              )}
            </div>

          </div>

          <div className='gap-y-6 flex'>

            <div className='gap-y-3 w-1/2 flex flex-col mt-0 md:mt-8'>
              <p className='text-sm font-semibold text-gray-500'>Tanggal Booking</p>
              <p className='text-sm font-semibold text-gray-800'>
                {format(data.schedules.date, 'd MMMM yyyy')}
              </p>
            </div>

            <div className='gap-y-3 w-1/2 flex flex-col mt-0 md:mt-8'>
              <p className='text-sm font-semibold text-gray-500'>Waktu Booking</p>
              {data.schedules.time.map((time, index) => (
                <p key={index} className='text-sm font-semibold text-gray-800'>
                  {time}
                </p>
              ))}
            </div>

          </div>
        </div>
      </div>

      <div className='md:w-1/2'>

        <p className='text-md font-semibold mb-4'>Input Data Pemesan</p>
        <div className='px-6 py-6 flex flex-col gap-y-6 border border-gray-300 rounded-xl mb-8 md:mb-0'>
          <input type='text' ref={name}
            placeholder="Input Nama Pemesan" 
            className='py-3 px-4 text-sm font-medium w-full bg-[#F5F5F5] placeholder:text-gray-600 border border-[#F5F5F5] focus:border-[#1C62CC] focus-visible:outline-none mr-2 rounded-lg px-4' />
          <input type='text' ref={phone}
            placeholder="Nomor Telepon" 
            className='py-3 px-4 text-sm font-medium w-full bg-[#F5F5F5] placeholder:text-gray-600 border border-[#F5F5F5] focus:border-[#1C62CC] focus-visible:outline-none mr-2 rounded-lg px-4' />
          <input type='text' ref={email}
            placeholder="Alamat Email" 
            className='py-3 px-4 text-sm font-medium w-full bg-[#F5F5F5] placeholder:text-gray-600 border border-[#F5F5F5] focus:border-[#1C62CC] focus-visible:outline-none mr-2 rounded-lg px-4' />
        </div>

        <p className='text-md font-semibold mt-6 mb-4'>Sistem Pembayaran</p>
        <div className='px-6 pt-6 pb-6 gap-y-8 border border-gray-300 rounded-xl'>

          <div className='flex items-center'>
            <Switch
              checked={fullPayment}
              onChange={toggleFullPayment}
              className={`${fullPayment ? 'bg-amber-300' : 'bg-gray-300'}
          relative inline-flex h-[24px] w-[44px] shrink-0 cursor-pointer rounded-lg border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2  focus-visible:ring-white focus-visible:ring-opacity-75`}
            >
              <span className="sr-only">Use setting</span>
              <span
                aria-hidden="true"
                className={`${fullPayment ? 'translate-x-5 bg-white' : 'translate-x-0 bg-gray-500'}
            pointer-events-none inline-block h-[20px] w-[20px] transform rounded-lg  shadow-lg ring-0 transition duration-200 ease-in-out`}
              />
            </Switch>
            <p className='text-xs font-semibold text-gray-700 ml-2'>Bayar Penuh</p>
          </div>

          {(data.venue.isDP) && (
            (data.schedules.isDP) ? (
              <>
              <p className='text-md text-gray-700 font-semibold mt-8 mb-6'>Uang Muka</p>
              <div className='flex flex-wrap gap-x-8 gap-y-8 items-center'>

                {percentages.map((percentage) => (
                  <div key={percentage} className='flex items-center' onClick={(e) => { setDP((percentage / 100) * total) }}>
                    <input type="radio" 
                      className={`appearance-none ${(DP === ((percentage / 100) * total)) ? 'bg-primaryYellow ring-primaryYellow' : 'bg-white ring-gray-300'} ring-2 ring-offset-2 outline-none rounded-lg cursor-pointer w-3 h-3 checked:border-none`} />
                    <p className='text-sm font-semibold text-gray-700 ml-3'>
                      {numberFormat((percentage / 100) * total)}
                    </p>
                  </div>
                ))}
    
              </div>
              </>
            ) : (
              <div className='mt-8 border border-orange-300 bg-[#FFFDF5] rounded-md p-4 text-center'>
                <h4 className='flex place-content-center text-amber-500 font-semibold leading-loose mb-2'>
                  <ExclamationCircleIcon className='h-6 mr-2' /> Uang Muka
                </h4>
                <p>
                  Anda tidak dapat memilih pembayaran dengan Uang Muka, 
                  Karena Tanggal yang anda pesan sudah mendekati hari Booking
                </p>
              </div>
            )
          )}
        </div>

        <div className='flex w-full justify-end my-6'>
          <button onClick={onNext} className='w-full md:w-fit bg-primaryRed text-white rounded-lg px-10 py-4 text-sm font-semibold '>
            Lanjut Pembayaran
          </button>
        </div>

      </div>



    </div>
  );
}

export default CheckoutConfirm;